/**
 * Error thrown when project data transformation or validation fails
 */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export class ProjectDataError extends Error {
    constructor(message, code, field, receivedData){
        super(message), _define_property(this, "code", void 0), _define_property(this, "field", void 0), _define_property(this, "receivedData", void 0), this.code = code, this.field = field, this.receivedData = receivedData;
        this.name = 'ProjectDataError';
    }
}
